import React from 'react';
import { Navigate } from 'react-router-dom';

/** Legacy /dashboard/trade — Trade workspace lives at /trade for every plan. */
export default function DashboardTradePage() {
  return <Navigate to="/trade" replace state={{ page: 'trade' }} />;
}
